import DatePicker from "react-multi-date-picker"
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"


const FilterOrdersDate = ({ dateValFrom, dateValTo, defaultdateValFrom = '', defaultdateValTo = '' }) => {

    const handleChangeDateFrom = (value) => {
        if (value) {
            let year = value.year
            let month = (value.month < 10 ? '0' + value.month : value.month)
            let day = (value.day < 10 ? '0' + value.day : value.day)
            let date = year + '/' + month + '/' + day
            dateValFrom(date)
        }
    }

    const handleChangeDateTo = (value) => {
        if (value) {
            let year = value.year
            let month = (value.month < 10 ? '0' + value.month : value.month)
            let day = (value.day < 10 ? '0' + value.day : value.day)
            let date = year + '/' + month + '/' + day
            dateValTo(date)
        }
    }


    return (
        <>
            <div className="flexRow">
                <DatePicker
                    onOpenPickNewDate={false}
                    value={defaultdateValFrom}
                    format="YYYY/MM/DD"
                    placeholder='از تاریخ'
                    calendar={persian}
                    locale={persian_fa}
                    onChange={handleChangeDateFrom}
                    calendarPosition="bottom-right"
                />
            </div>
            <div className="flexRow">
                <DatePicker
                    onOpenPickNewDate={false}
                    value={defaultdateValTo}
                    format="YYYY/MM/DD"
                    placeholder='تا تاریخ'
                    calendar={persian}
                    locale={persian_fa}
                    onChange={handleChangeDateTo}
                    calendarPosition="bottom-right"
                />
            </div>
        </>
    );
}

export default FilterOrdersDate;